import { render, staticRenderFns } from "./ExamResult.vue?vue&type=template&id=61f97c70&scoped=true&"
import script from "./ExamResult.vue?vue&type=script&lang=js&"
export * from "./ExamResult.vue?vue&type=script&lang=js&"
import style0 from "./ExamResult.vue?vue&type=style&index=0&id=61f97c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f97c70",
  null
  
)

export default component.exports